import React, { FC } from 'react';

import { IImageData } from '../../../pages/Root/services/api/interfaces.ts';
import Image from '../../../components/Image/Image.tsx';
import TextParser from '../../../pages/Root/components/TextParser/TextParser.tsx';
import PublisherLogo from '../PublisherLogo/PublisherLogo.tsx';
import { StorySize } from '../../types/story-types';

import './StoryLarge.scss';

export interface StoryLargeProps {
  imageList: IImageData[];
  title: string;
  description: string;
  interestName: string[];
  onClick?: () => void;
  publisherLogo?: string;
  publisherName?: string;
  hidePublisher: boolean;
}

const StoryLarge: FC<StoryLargeProps> = ({
  imageList,
  title,
  description,
  onClick,
  interestName,
  publisherLogo,
  publisherName,
  hidePublisher = false,
}: StoryLargeProps) => {
  return (
    <div onClick={onClick} className="story-large">
      <div className="story-image-container">
        <Image
          withSkeleton
          alt={title}
          imageList={imageList}
          className="story-image-cr"
          imageContainerClassName="border-radius-sm"
        ></Image>
      </div>
      <div className="story-text">
        {!hidePublisher && publisherLogo && (
          <PublisherLogo
            publisherLogo={publisherLogo}
            publisherName={publisherName ?? ''}
            storySize={StorySize.LARGE}
          />
        )}
        <div className="home-cover-card__interest-name">
          {interestName.length > 0 ? interestName[0] : ''}
        </div>
        <TextParser
          text={title}
          option={{
            paragraphClass: 'story-title',
          }}
        />
        <div className="story-description">
          <TextParser
            text={description}
            option={{ isIgnoreLinks: true, removeHTML: true }}
          />
        </div>
      </div>
    </div>
  );
};

export default StoryLarge;
